import type { ScheduleStats } from '../app/scheduleModel';

interface ScheduleHeaderProps {
  date: string;
  now: Date;
  stats: ScheduleStats;
  onRefresh: () => void;
}

const weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

function formatDate(dateText: string): string {
  const date = new Date(`${dateText}T00:00:00`);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}年${month}月${day}日 ${weekdays[date.getDay()]}`;
}

function formatClock(date: Date): string {
  return [date.getHours(), date.getMinutes(), date.getSeconds()]
    .map((unit) => String(unit).padStart(2, '0'))
    .join(':');
}

export function ScheduleHeader({ date, now, stats, onRefresh }: ScheduleHeaderProps) {
  return (
    <header className="schedule-header">
      <div className="schedule-date">
        <strong>{formatDate(date)}</strong>
        <span>演示时间 {formatClock(now)}</span>
      </div>
      <div className="schedule-stats" aria-label="今日课程统计">
        <span>今日课程 <b>{stats.total}</b></span>
        <span className="is-current">上课中 <b>{stats.current}</b></span>
        <span className="is-future">等待 <b>{stats.future}</b></span>
        <span>已上完 <b>{stats.past}</b></span>
      </div>
      <div className="schedule-refresh">
        <span>模拟数据</span>
        <button type="button" className="plain-button" onClick={onRefresh}>刷新</button>
      </div>
    </header>
  );
}
